import * as Event from '../tools/Event';
import { addClass, removeClass } from '../tools/DOM';
import Flickity from 'flickity';
import 'flickity-imagesloaded';


export const init = () => {
	const elements = [...document.querySelectorAll('.js-carousel')];

	const OPTIONS = {
		imagesLoaded: true,
		groupCells: true,
		contain: true,
		pageDots: false,
		prevNextButtons: false,
	};
	const DISABLED_CLASS = 'is-disabled';

	const checkArrows = (carousel, arrows) => {
		const { prev, next } = arrows;
		const slides = carousel.slides.length;
		const index = carousel.selectedIndex;

		if (slides === 1) {
			if (next) {
				addClass(next, DISABLED_CLASS);
			}
			if (prev) {
				addClass(prev, DISABLED_CLASS);
			}

			return;
		}

		if (next) {
			removeClass(next, DISABLED_CLASS);
		}
		if (prev) {
			removeClass(prev, DISABLED_CLASS);
		}

		if (index === 0) {
			if (prev) {
				addClass(prev, DISABLED_CLASS);
			}
		} else if (index + 1 === slides) {
			if (next) {
				addClass(next, DISABLED_CLASS);
			}
		}
	};

	const init = (element) => {
		const carousel = new Flickity(element, OPTIONS);
		const prev = element.parentNode.querySelector('.arrow--prev');
		const next = element.parentNode.querySelector('.arrow--next');

		checkArrows(carousel, { prev, next });

		carousel.on('select', () => {
			checkArrows(carousel, { prev, next });
		});

		if (next) {
			Event.on(next, 'click', (event) => {
				event.preventDefault();
				carousel.next();
			});
		}

		if (prev) {
			Event.on(prev, 'click', (event) => {
				event.preventDefault();
				carousel.previous();
			});
		}
	};


	elements.forEach(init);
};



// WEBPACK FOOTER //
// ./src/js/components/carousel.js